import * as React from 'react';
import cx from 'classnames';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TravelPolicyTableRows from './TravelPolicyTableRows';
import Loader from 'components/Loader/Loader';
import { TravelPolicyTabTypes } from 'components/UserDetails/UserDetail';
import { AIRLINE_NAME_MAP, CAR_VENDOR_MAP } from '../../../helpers';

const styles = require('./styles.pcss');

type Props = {
  isLoading: boolean;
  flightPolicy: any;
  carPolicy: any;
  product: TravelPolicyTabTypes;
};

const tableLabels: Record<string, { name: string; description: string }> = {
  preferredCarRental: {
    name: 'Preferred Car Rental',
    description: 'Car rental providers that are within policy.',
  },
  preferredCarType: {
    name: 'Preferred Car Type',
    description: 'Preferred car types that are within policy.',
  },
  preferredAirlines: {
    name: 'Preferred Airlines',
    description: 'Airline providers that are within policy.',
  },
};

enum CarTypes {
  RegularCabPickup = 'regularCabPickup',
  Car = 'car',
  SUV = 'suv',
  Convertible = 'convetible',
  Van = 'van',
  Special = 'special',
  Recreational = 'recreational',
  Limousine = 'limousine',
  Truck = 'truck',
  Sport = 'sport',
  Monospace = 'monospace',
  Roadster = 'roadster',
  Crossover = 'Crossover',
  AllTerrain = 'allTerrain',
  Coupe = 'coupe',
  ExtendedCabPickup = 'extendedCabPickup',
}

const CAR_TYPE_LABEL_MAP = {
  [CarTypes.RegularCabPickup]: 'Regular Cab Pickup',
  [CarTypes.Car]: 'Car',
  [CarTypes.SUV]: 'SUV',
  [CarTypes.Convertible]: 'Convetible',
  [CarTypes.Van]: 'Van',
  [CarTypes.Special]: 'Special',
  [CarTypes.Recreational]: 'Recreational Vehicle',
  [CarTypes.Limousine]: 'Limousine',
  [CarTypes.Truck]: 'Truck',
  [CarTypes.Sport]: 'Sport',
  [CarTypes.Monospace]: 'Monospace',
  [CarTypes.Roadster]: 'Roadster',
  [CarTypes.Crossover]: 'Crossover',
  [CarTypes.AllTerrain]: 'Open Air All Terrain',
  [CarTypes.Coupe]: 'Coupe',
  [CarTypes.ExtendedCabPickup]: 'Extended Cab Pickup',
};

const defaultText = '-';

const renderListText = (
  list: string[] = [],
  map: Record<string, string>,
): string =>
  list?.length ? list.map((val) => map[val]).join(', ') : defaultText;

class Preferences extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const {
      isLoading,
      product,
      flightPolicy = {},
      carPolicy = {},
    } = this.props;

    const { preferredAirlines: { list: preferredAirlineList = [] } = {} } =
      flightPolicy || {};
    const {
      preferredRental: { list: preferredRentalList = [] } = {},
      preferredType: { list: preferredTypeList = [] } = {},
    } = carPolicy || {};

    const preferredAirlineText = renderListText(
      preferredAirlineList,
      AIRLINE_NAME_MAP,
    );

    const preferredRentalText = renderListText(
      preferredRentalList,
      CAR_VENDOR_MAP,
    );

    const preferredTypeText = renderListText(
      preferredTypeList,
      CAR_TYPE_LABEL_MAP,
    );

    return (
      product !== TravelPolicyTabTypes.hotel && (
        <Paper
          className={
            isLoading ? cx(styles.paper, styles.loading) : styles.paper
          }
        >
          <div className={styles.policyRules}>
            <h2>Preferences</h2>
            <div>
              <Loader visible={isLoading} />
            </div>
            <Table>
              <TableBody>
                {product === TravelPolicyTabTypes.car && (
                  <>
                    <TravelPolicyTableRows
                      key={2}
                      text={tableLabels.preferredCarRental}
                      product={product}
                      car={preferredRentalText}
                    />
                    <TravelPolicyTableRows
                      key={4}
                      text={tableLabels.preferredCarType}
                      product={product}
                      car={preferredTypeText}
                    />
                  </>
                )}
                {product === TravelPolicyTabTypes.flight && (
                  <TravelPolicyTableRows
                    key={2}
                    text={tableLabels.preferredAirlines}
                    product={product}
                    flight={preferredAirlineText}
                  />
                )}
              </TableBody>
            </Table>
          </div>
        </Paper>
      )
    );
  }
}

export default Preferences;
